import React from 'react';
import { Trans } from '@lingui/macro';
import type { CompanyResponse } from '~/payment-cards-feature';
import { DialogContent } from './StepContent';
import { DialogContentWithoutCVR } from './StepContentWithoutCVR';

interface CompanyInfoStepProps {
    currentCompanyData: CompanyResponse;
    refetchCompanyData: () => Promise<void>;
    handleNext: () => void;
}

export const CompanyInfoStep: React.FC<CompanyInfoStepProps> = ({ currentCompanyData, refetchCompanyData, handleNext }) => {
    const onSettingsSaved = () => {
        refetchCompanyData();
    };

    return (
        <>
            <h1 className="text-3xl mb-4 text-center">
                <Trans>Confirm your company data</Trans>
            </h1>

            <>
                {!currentCompanyData.model.cvr && (
                    <DialogContentWithoutCVR onSettingsSaved={onSettingsSaved} currentCompanyData={currentCompanyData} />
                )}
                {currentCompanyData.model.cvr && (
                    <DialogContent
                        currentCompanyData={currentCompanyData}
                        handleNext={handleNext}
                        onSettingsSaved={onSettingsSaved}
                    />
                )}
            </>
        </>
    );
};
